import { useState } from "react";
import KalPopup from "./KalPopup";

export default function KalIndicator({ hasRecurringPayment }) {
  const [showPopup, setShowPopup] = useState(false);
  const color = hasRecurringPayment ? "bg-green-500" : "bg-red-500";

  return (
    <>
      <div
        onClick={() => !hasRecurringPayment &&setShowPopup(true)}
        // className={`cursor-pointer text-white text-xs font-semibold px-3 py-1 rounded-lg ${color} shadow-md hover:opacity-90 transition`}
        className={`avatar ring-2 flex justify-center items-center ${color} shadow-md hover:opacity-90 transition`}
      >
        
        קל"ה
      </div>

      <KalPopup 
        show={showPopup}
        onClose={() => setShowPopup(false)}
      />
    </>
  );
}
